/**
 * Cancel payment response DTO
 */
export class CancelPaymentResponseDto {
	transactionId!: string;
	status?: string;
}
